import { action, observable } from 'mobx';
import { api } from '../config';

// Components
import SessionStore from './SessionStore';

let obx = observable({
  // Schedule sync
  scheduleSync: action(function(data, callback, failCallback, allowError = false){
    SessionStore.startLoading('Loading…', 'scheduleSync');

    api.post(`/installs/${SessionStore.userData.installSid}/sync`, data)
      .then(response => {
        SessionStore.finishLoading('scheduleSync');

        if(callback) {
          callback();
        }
      })
      .catch(error => {
        if (allowError && error.response.data.code === '1529') {
          SessionStore.finishLoading('scheduleSync', true);
          if (failCallback) {
            failCallback();
          }
        } else {
          SessionStore.throwError(error);
        }
      });
  })
});

export default obx;



// WEBPACK FOOTER //
// ./src/app/stores/SyncStore.js